import { render, staticRenderFns } from "./HostsTable.vue?vue&type=template&id=0c5bae85&scoped=true&"
import script from "./HostsTable.vue?vue&type=script&lang=js&"
export * from "./HostsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5bae85",
  null
  
)

export default component.exports